import { render, staticRenderFns } from "./UserApplication.vue?vue&type=template&id=397fdbec&scoped=true&"
import script from "./UserApplication.vue?vue&type=script&lang=js&"
export * from "./UserApplication.vue?vue&type=script&lang=js&"
import style0 from "./UserApplication.vue?vue&type=style&index=0&id=397fdbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397fdbec",
  null
  
)

export default component.exports